import './BroadcasterSelector.css';
import TypeaheadField from './TypeaheadField';
import { BROADCASTER_OPTIONS } from './discoveryOptions';

const broadcasterOptions = BROADCASTER_OPTIONS.map((option) => ({
  ...option,
  key: option.login ?? option.displayName.toLowerCase(),
}));

function BroadcasterSelector({ value, onChange, disabled = false }) {
  const getLabel = (option) =>
    option?.displayName ?? option?.login ?? option?.name ?? option?.label ?? '';
  const getKey = (option) =>
    option?.key ?? option?.id ?? option?.login ?? option?.displayName ?? option?.name ?? '';

  return (
    <div className="BroadcasterSelector">
      <TypeaheadField
        label="Broadcaster"
        placeholder="Search streamers"
        selectedOption={value}
        onSelect={onChange}
        options={broadcasterOptions}
        getOptionLabel={getLabel}
        getOptionKey={getKey}
        disabled={disabled}
        description="Refine clips from a specific channel"
        allowFreeInput
      />
    </div>
  );
}

export default BroadcasterSelector;
